export class Table {
    ID: number;
    Name: string;
    FriendlyName: string;
    FeatureID: number;
}

export default Table;